import PropTypes from 'prop-types'
import React from 'react'
import { ReactComponent as SvgIcon } from '@fortawesome/fontawesome-pro/svgs/light/plus-circle.svg'
import BaseIcon from '../../BaseIcon'

const AddCircle = ({ className }) => {
	return <BaseIcon component={SvgIcon} className={className} viewBox="0 0 512 512" />
}

AddCircle.propTypes = {
	className: PropTypes.string,
}

export default AddCircle
